import React from "react";
import "./Gdprivacy.css";
import "./Gdprivacy.css";
import Gdnav from "./Gdnav";
import Gdfooter from "./Gdfooter";

const DOMAIN = "ruttientindung3s.com";
const WEBSITE_URL = `https://${DOMAIN}`;
export default function Gdprivacy() {
  return (
    <main className="pp">
      <Gdnav />
      <div className="pp__container">
        {/* Title */}
        <header className="pp__header">
          <h1 className="pp__title">CHÍNH SÁCH BẢO MẬT</h1>

          <div className="pp__meta">
            <span className="pp__metaIcon" aria-hidden="true">
              ▦
            </span>
            <span>Đăng ngày 22-02-2026</span>
          </div>
        </header>

        {/* Content */}
        <article className="pp__content">
          <p>
            Tại <strong>{DOMAIN}</strong> sự riêng tư của khách hàng là điều vô
            cùng quan trọng. Vì thế, <strong>{DOMAIN}</strong> sẽ chỉ thu thập
            những thông tin cần thiết và có liên quan đến giao dịch giữa quý
            khách hàng và <strong>{DOMAIN}</strong>. Những thông tin này gồm có
            tên, số điện thoại và một số thông tin khác của quý khách hàng theo
            cách được đề ra trong “Chính Sách Bảo Mật” này.
          </p>

          <p>
            Quý khách có thể ghé thăm trang web{" "}
            <a
              className="pp__link"
              href="{DOMAIN}"
              target="_blank"
              rel="noreferrer"
            >
              {DOMAIN}
            </a>{" "}
            mà không cần phải cung cấp bất kỳ thông tin cá nhân nào. Khi truy
            cập trang web, quý khách sẽ luôn ở trong tình trạng vô danh trừ khi
            quý khách đăng ký tài khoản trên web và đăng nhập vào tài khoản đó.
          </p>

          <p>
            Quy định Bảo mật của <strong>Gia Dụng Nhanh</strong> hoàn toàn tuân
            theo Quy định của Pháp luật về Bảo mật thông tin cá nhân.
          </p>

          {/* Section 1 */}
          <h2 className="pp__h2">1. Thu thập thông tin cá nhân</h2>
          <ul className="pp__ul">
            <li>
              <strong>{DOMAIN}</strong> không bán, chia sẻ hay trao đổi thông
              tin cá nhân của khách hàng thu thập trên website cho một bên thứ
              ba nào khác.
            </li>
            <li>
              Thông tin cá nhân của quý khách hàng sẽ chỉ được sử dụng trong nội
              bộ công ty <strong>{DOMAIN}</strong>.
            </li>
            <li>
              Khi quý khách đăng ký tài khoản tại{" "}
              <strong>Gia Dụng Nhanh</strong>, thông tin cá nhân mà chúng tôi
              thu thập bao gồm:
              <ul className="pp__ul pp__ul--indent">
                <li>Họ &amp; Tên</li>
                <li>Địa chỉ giao hàng</li>
                <li>Địa chỉ</li>
                <li>Email</li>
                <li>Số điện thoại cố định</li>
                <li>Số điện thoại di động</li>
                <li>Ngày sinh</li>
                <li>Giới tính</li>
              </ul>
            </li>
          </ul>

          <p>
            Những thông tin trên sẽ được sử dụng cho một hoặc tất cả các mục
            đích sau đây:
          </p>
          <ul className="pp__ul">
            <li>
              Giao hàng quý khách đã mua tại <strong>{DOMAIN}</strong>
            </li>
            <li>Thông báo về việc giao hàng và hỗ trợ khách hàng</li>
            <li>Cung cấp thông tin liên quan đến sản phẩm</li>
            <li>
              Xử lý đơn đặt hàng và cung cấp dịch vụ và thông tin qua trang web
              của chúng tôi theo yêu cầu của quý khách
            </li>
          </ul>

          <p>
            Ngoài ra, chúng tôi sẽ sử dụng thông tin quý khách cung cấp để hỗ
            trợ quản lý tài khoản khách hàng:
          </p>
          <ul className="pp__ul">
            <li>
              Xác nhận và thực hiện các giao dịch tài chính liên quan đến các
              khoản thanh toán trực tuyến của quý khách
            </li>
            <li>Kiểm tra dữ liệu từ trang web của chúng tôi</li>
            <li>
              Cải thiện giao diện và/hoặc nội dung của các trang mục trên trang
              web và tùy chỉnh để dễ dàng hơn khi sử dụng
            </li>
            <li>Nhận diện khách đến thăm trang web</li>
            <li>Nghiên cứu về nhân khẩu học của người sử dụng</li>
            <li>
              Gửi đến quý khách thông tin mà chúng tôi nghĩ sẽ có ích hoặc do
              quý khách yêu cầu, bao gồm thông tin về sản phẩm và dịch vụ (khi
              quý khách đồng ý không phản đối việc được liên lạc)
            </li>
          </ul>

          <p>
            <strong>{DOMAIN}</strong> có thể chia sẻ tên và địa chỉ của quý
            khách cho dịch vụ chuyển phát nhanh hoặc nhà cung cấp của chúng tôi
            để có thể giao hàng cho quý khách.
          </p>

          <p>
            Khi quý khách đăng ký làm thành viên trên{" "}
            <a
              className="pp__link"
              href="{DOMAIN}"
              target="_blank"
              rel="noreferrer"
            >
              {DOMAIN}
            </a>
            , chúng tôi cũng sẽ sử dụng thông tin cá nhân của quý khách để gửi
            các thông tin khuyến mãi/tiếp thị. Quý khách có thể hủy nhận các
            thông tin đó bất kỳ lúc nào bằng cách sử dụng chức năng hủy đăng ký
            trong các thông báo quảng cáo.
          </p>

          <p>
            Các khoản thanh toán mà quý khách thực hiện qua trang web sẽ được xử
            lý bởi <strong>{DOMAIN}</strong>. Quý khách phải cung cấp cho chúng
            tôi (hoặc đại lý của chúng tôi) những thông tin chính xác và phải
            luôn cập nhật thông tin và thông báo cho chúng tôi biết nếu có thay
            đổi.
          </p>

          <p>
            Chi tiết đơn hàng của quý khách sẽ được chúng tôi lưu trữ nhưng vì
            lý do bảo mật, chúng tôi không công khai trực tiếp được. Tuy nhiên,
            quý khách có thể kiểm tra thông tin đó bằng cách đăng nhập vào tài
            khoản riêng của mình trên trang web.
          </p>

          <p>
            Quý khách cần bảo đảm là thông tin được truy cập một cách bí mật và
            không làm lộ cho một bên thứ ba không có quyền. Chúng tôi sẽ không
            chịu trách nhiệm đối với việc sử dụng sai mật khẩu trừ khi đó là lỗi
            của chúng tôi.
          </p>

          {/* Section 2 */}
          <h2 className="pp__h2">2. Cập nhật thông tin cá nhân</h2>
          <p>
            Quý khách có thể cập nhật thông tin cá nhân của mình bất kỳ lúc nào
            bằng cách đăng nhập vào trang web{" "}
            <a
              className="pp__link"
              href="{DOMAIN}"
              target="_blank"
              rel="noreferrer"
            >
              {DOMAIN}
            </a>
            .
          </p>

          {/* Section 3 */}
          <h2 className="pp__h2">3. Bảo mật thông tin cá nhân</h2>
          <p>
            <strong>{DOMAIN}</strong> đảm bảo rằng mọi thông tin thu thập được
            sẽ được lưu giữ an toàn. Chúng tôi bảo vệ thông tin cá nhân của quý
            khách bằng cách:
          </p>
          <ul className="pp__ul">
            <li>Giới hạn truy cập thông tin cá nhân</li>
            <li>
              Sử dụng sản phẩm công nghệ để ngăn chặn truy cập máy tính trái
              phép
            </li>
            <li>
              Xóa thông tin cá nhân của quý khách khi không còn cần thiết cho
              mục đích lưu trữ hồ sơ
            </li>
          </ul>

          {/* Section 4 */}
          <h2 className="pp__h2">4. Tiết lộ thông tin cá nhân</h2>
          <p>
            Chúng tôi sẽ không chia sẻ thông tin của quý khách cho bất kỳ một
            công ty nào khác ngoại trừ những công ty và các bên thứ ba có liên
            quan trực tiếp đến việc giao hàng mà quý khách đã mua tại{" "}
            <a
              className="pp__link"
              href="{DOMAIN}"
              target="_blank"
              rel="noreferrer"
            >
              {DOMAIN}
            </a>
            .
          </p>

          <p>
            Trong một vài trường hợp đặc biệt, <strong>{DOMAIN}</strong> có thể
            bị yêu cầu phải tiết lộ thông tin cá nhân (khi có căn cứ cho việc
            tiết lộ là cần thiết để ngăn chặn các mối đe dọa về tính mạng và sức
            khỏe hoặc cho mục đích thực thi pháp luật).
          </p>

          <p>
            Thu thập dữ liệu máy tính khi quý khách đến thăm{" "}
            <a
              className="pp__link"
              href="{DOMAIN}"
              target="_blank"
              rel="noreferrer"
            >
              {DOMAIN}
            </a>{" "}
            (máy chủ có thể tự động lưu trữ thông tin mà trình duyệt của quý
            khách gửi đến) bao gồm:
          </p>
          <ul className="pp__ul">
            <li>Địa chỉ IP của quý khách</li>
            <li>Loại trình duyệt</li>
            <li>
              Các trang web mà quý khách đã ghé thăm trước khi đến trang web của
              chúng tôi
            </li>
            <li>Những trang mục trong {DOMAIN} mà quý khách ghé thăm</li>
            <li>
              Khoảng thời gian quý khách giành ra để xem những trang mục đó, sản
              phẩm, tìm kiếm thông tin trên trang web, thời gian và ngày tháng
              truy cập, và các số liệu thống kê khác
            </li>
          </ul>

          <p>
            Dữ liệu này được thu thập cho mục đích phân tích và đánh giá để góp
            phần cải thiện trang web, dịch vụ và sản phẩm mà chúng tôi cung cấp.
          </p>

          {/* Section 5 */}
          <h2 className="pp__h2">5. Sử dụng Cookie</h2>
          <p>
            Khi khách hàng sử dụng dịch vụ hoặc xem nội dung do{" "}
            <strong>Gia Dụng Nhanh</strong> cung cấp, chúng tôi tự động thu thập
            và lưu trữ một số thông tin trong nhật ký máy chủ, bao gồm:
          </p>
          <ul className="pp__ul">
            <li>
              Các chi tiết về cách khách hàng sử dụng dịch vụ (ví dụ: truy vấn
              tìm kiếm)
            </li>
            <li>Địa chỉ giao thức Internet</li>
            <li>
              Thông tin sự cố thiết bị như lỗi, hoạt động hệ thống, cài đặt phần
              cứng, loại trình duyệt, ngôn ngữ, ngày và thời gian yêu cầu và URL
              giới thiệu
            </li>
            <li>
              Cookie có thể nhận dạng duy nhất trình duyệt hoặc tài khoản của
              khách hàng
            </li>
          </ul>

          {/* Section 6 */}
          <h2 className="pp__h2">6. Chính sách bảo mật thanh toán</h2>
          <ul className="pp__ul">
            <li>
              Hệ thống thanh toán thẻ trên{" "}
              <a
                className="pp__link"
                href="{DOMAIN}"
                target="_blank"
                rel="noreferrer"
              >
                {DOMAIN}
              </a>{" "}
              được cung cấp bởi các đối tác cổng thanh toán đã được cấp phép
              hoạt động hợp pháp tại Việt Nam. Do đó, các tiêu chuẩn bảo mật
              thanh toán thẻ của <strong>{DOMAIN}</strong> đảm bảo tuân thủ theo
              các tiêu chuẩn bảo mật của đối tác cổng thanh toán.
            </li>
            <li>
              Ngoài ra, <strong>{DOMAIN}</strong> còn có các tiêu chuẩn bảo mật
              giao dịch thanh toán riêng để đảm bảo an toàn các thông tin thanh
              toán của khách hàng.
            </li>
          </ul>

          {/* Section 7 */}
          <h2 className="pp__h2">7. Thay đổi của Chính sách Bảo mật</h2>
          <p>
            <a
              className="pp__link"
              href="{DOMAIN}"
              target="_blank"
              rel="noreferrer"
            >
              {DOMAIN}
            </a>{" "}
            có quyền thay đổi và chỉnh sửa Quy định Bảo mật vào bất kỳ lúc nào.
            Bất cứ thay đổi nào về chính sách này đều được đăng trên trang web
            của chúng tôi.
          </p>

          <hr className="pp__hr" />

          {/* Author box */}
          <section className="pp__author">
            <div className="pp__avatar" aria-hidden="true">
              <span className="pp__avatarMark" />
            </div>

            <div className="pp__authorText">
              <div className="pp__authorTitle">
                <strong>Tác giả:</strong> {DOMAIN}
              </div>
            </div>
          </section>
        </article>
      </div>
      <Gdfooter />
    </main>
  );
}
